import { COUNTRY_CODES } from "./countries";

export const DOCUMENT_TYPES = {
  [COUNTRY_CODES.ECUADOR]: [
    { value: "Invoice", label: "Factura" },
    { value: "Credit Memo", label: "Notas de crédito" }
  ],
  [COUNTRY_CODES.PARAGUAY]: [
    { value: "Invoice", label: "Factura" },
    { value: "Credit Memo", label: "Notas de crédito" }
  ],
  [COUNTRY_CODES.HONDURAS]: [
    { value: "Invoice", label: "Factura" },
    { value: "Credit Memo", label: "Notas de crédito" }
  ],
  [COUNTRY_CODES.ELSALVADOR]: [
    { value: "Invoice", label: "Factura" },
    { value: "Credit Memo", label: "Notas de crédito" }
  ],
  [COUNTRY_CODES.PERU]: [
    { value: "Invoice", label: "Factura" },
    { value: "Boleta", label: "Boleta de Venta" },
    { value: "Credit Memo", label: "Notas de crédito" }
  ]
};

export const getDocumentTypes = (countryCode) => {
  return DOCUMENT_TYPES[countryCode] || DOCUMENT_TYPES[COUNTRY_CODES.ECUADOR];
};

export const matchesDocumentType = (actualType, expectedType, countryCode) => {
  if (expectedType === "Invoice") {
    return actualType === "Invoice" || (countryCode === COUNTRY_CODES.PERU && actualType === "Boleta");
  }
  return actualType === expectedType;
};

// Map el tipo de documento de la UI a el tipo de documento que espera BC
export const UI_TO_SYSTEM_MAP = {
  [COUNTRY_CODES.PERU]: {
    "Invoice": "01",
    "Boleta": "03",
    "Credit Memo": "07"
  }
};

export const mapUiToSystemType = (value, countryCode) => {
  return UI_TO_SYSTEM_MAP[countryCode]?.[value] || value;
};

